import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./transition.css";
import "./i18n";

import ResizeObserver from "resize-observer-polyfill";
import FSendApp from "./fsend/FSendApp";

if (window.ResizeObserver === undefined) {
  console.log("ResizeObserver polyfill.");
  window.ResizeObserver = ResizeObserver;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <FSendApp />
  </StrictMode>
);
